import $ from 'jquery';
import config from './../../../config';

// Save Department
export function save_department( data ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'department/',
			data: {
                method: 'SAVE_DEPARTMENT',
				data: data
            }
		})
		.then(function (response) {
			dispatch({
				type: "SAVE_DEPARTMENT",
				department: response
			})
		})

	}
}

// Get Department
export function get_department(){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'department/',
			data: {
                method: 'GET_DEPARTMENT'
            }
		})
		.then(function (response) {
			dispatch({
				type: "GET_DEPARTMENT",
				department: response
			})
		})

	}
}

// Delete Department
export function delete_department( id ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'department/',
			data: {
				method: 'DELETE_DEPARTMENT',
				id: id
            }
		})
		.then(function (response) {
			dispatch({
				type: "DELETE_DEPARTMENT",
				department: response
			})
		})

	}
}

// Get By ID Department
export function get_department_by_id( id ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'department/',
			data: {
				method: 'GET_BY_ID_DEPARTMENT',
				id: id
            }
		})
		.then(function (response) {
			dispatch({
				type: "GET_BY_ID_DEPARTMENT",
				department: response
			})
		})

	}
}


// Edit Department
export function edit_department( data ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'department/',
			data: {
				method: 'EDIT_DEPARTMENT',
				data: data
            }
		})
		.then(function (response) {
			dispatch({
				type: "EDIT_DEPARTMENT",
				department: response
			})
		})

	}
}


// WEBPACK FOOTER //
// ./src/pages/department/actions/department.action.js